import React, { useRef, useState } from "react";
import { Divider, Tab, Tabs } from "@monolith-forensics/monolith-ui";
import { Card } from "@mui/material";
import moment from "moment";
import ReportMetrics from "./ReportMetrics";
import SavedReports from "./SavedReports";
import ReportComposition from "./ReportComposition";
import { EditReportPopup } from "../../EditReportPopup";
import AcquisitionGrid from "./AcquisitionGrid.js";
import ReportParametersPanel, {
  ACQUISITIONS_PARAMS_FIELDS,
} from "../ReportParametersPanel";

const ReportDetails = ({ reportInfo }) => {
  return (
    <Card
      style={{
        padding: "20px",
        textAlign: "left",
        flexGrow: 1,
        flexBasis: "10px",
        marginRight: 15,
      }}
    >
      <div
        style={{
          fontSize: "larger",
        }}
      >
        Report Details
      </div>
      <Divider style={{ margin: "16px 0" }} />
      <div
        style={{
          minWidth: "300px",
          overflowY: "auto",
          maxHeight: "175px",
          paddingRight: "10px",
        }}
      >
        {reportInfo.report_id && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Report ID: </div>
            <div>{reportInfo.report_id}</div>
          </div>
        )}
        {reportInfo.name && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Report Name: </div>
            <div>{reportInfo.name}</div>
          </div>
        )}
        {reportInfo.created_at && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Created On:</div>
            <div>{moment(reportInfo.created_at).format("MMMM DD, YYYY")}</div>
          </div>
        )}
        {reportInfo.created_by && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Created By: </div>
            <div>{reportInfo.created_by}</div>
          </div>
        )}
        {reportInfo.category && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Category: </div>
            <div>{reportInfo.category}</div>
          </div>
        )}
      </div>
    </Card>
  );
};

const TabSection = ({ reportInfo }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div style={{ minHeight: "450px" }}>
      <Tabs value={selectedTab} onChange={setSelectedTab}>
        <Tab value={0}>Saved Reports</Tab>
        <Tab value={1}>Acquisitions</Tab>
      </Tabs>
      {selectedTab === 0 && <SavedReports reportInfo={reportInfo} />}
      {selectedTab === 1 && <AcquisitionGrid reportInfo={reportInfo} />}
    </div>
  );
};

const AcquisitionsReport = ({ reportInfo, setFormUpdated }) => {
  const editReportPopup = useRef(null);

  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: "20px",
          userSelect: "text",
        }}
      >
        <ReportDetails reportInfo={reportInfo} />
        <ReportParametersPanel
          reportInfo={reportInfo}
          editReportPopup={editReportPopup}
          filterFields={ACQUISITIONS_PARAMS_FIELDS}
        />
        <ReportMetrics reportInfo={reportInfo} />
      </div>
      <ReportComposition reportInfo={reportInfo} />
      <TabSection reportInfo={reportInfo} />
      <EditReportPopup
        editReportPopup={editReportPopup}
        reportInfo={reportInfo}
        setFormUpdated={setFormUpdated}
      />
    </>
  );
};

export default AcquisitionsReport;
